module.exports = __webpack_public_path__ + "d913881d0a4c907209fe674b1a57d26b.svg";